import Model from '@/lib/data/Model';

class AddressDivision extends Model {
    static idProperty = 'id';

    fields = ['id', 'name', 'organization_id'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            method: 'DELETE',
            url: '/customer/address/division/delete',
            params: ['id'],
        },
    ];
}

export default AddressDivision;
